export var pageEditActions;
(function (pageEditActions) {
    pageEditActions["TOGGLE_EDIT"] = "page:edit:TOGGLE_EDIT";
    pageEditActions["TOGGLE_HELPERS"] = "page:edit:TOGGLE_HELPERS";
})(pageEditActions || (pageEditActions = {}));
